export default "fragment ShopAttributes on Shop{id name shippingInfo_v4{...ShippingInfoV4Attributes}}"